import { render, staticRenderFns } from "./VoteHistory.vue?vue&type=template&id=3e0fedbe&scoped=true&"
import script from "./VoteHistory.vue?vue&type=script&lang=js&"
export * from "./VoteHistory.vue?vue&type=script&lang=js&"
import style0 from "./VoteHistory.vue?vue&type=style&index=0&id=3e0fedbe&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e0fedbe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VSkeletonLoader})
